const LOCK_REASONS = {
  CUSTOMER_ENDED: 'customer_ended',
  TIMED_OUT: 'timed_out',
  USER_ENDED: 'user_ended',
  UNSPECIFIED: 'unspecified',
};

LOCK_REASONS.DEFAULT = LOCK_REASONS.UNSPECIFIED;
LOCK_REASONS.ALL = Object.keys(LOCK_REASONS);

export default LOCK_REASONS;
